import { useTranslation } from 'react-i18next';
import { Tooltip, MenuItem } from '@material-ui/core';
import SelectUi from '@mui/material/Select';
import { Controller, UseFormReturn } from 'react-hook-form';
import { projectSimulatorFieldRules, selectStyle } from '../utils';
import RectangleSVG from '../../../../assets/images/projectSimulator/RectangleSVG';
import { InputProjectSimulator } from '../ProjectSimulator';

type GeneralConceptionProps = {
  generalConception: GeneralConceptionData;
  form: UseFormReturn;
};

export type GeneralConceptionData = {
  meanHeight: number;
  numberOfLevels: number;
  morphology: {
    value: number;
    type: {
      width: number;
      length: number;
    };
  };
};

function GeneralConception({ generalConception, form }: GeneralConceptionProps) {
  const { t } = useTranslation();

  return (
    <div className="form-block">
      <h2 className="form-title">
        {t('APP.PROJECT.SIMULATOR.QUICK_SIMULATION.GENERAL.CONCEPTION.TITLE', {
          defaultValue: 'Conception générale',
        })}
      </h2>

      <hr className="line-title-separation" />

      <div
        style={{
          display: 'flex',
          paddingLeft: '24px',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            rowGap: '12px',
          }}
        >
          <div>
            <label
              className="form-label"
              style={{
                display: 'flex',
              }}
              htmlFor="morphology"
            >
              {t('APP.PROJECT.SIMULATOR.QUICK_SIMULATION.FORM.LABEL.MORPHOLOGY', {
                defaultValue: 'Type de morphologie',
              })}
            </label>
            <Controller
              name="morphology"
              control={form.control}
              defaultValue={generalConception.morphology.value}
              render={({ field }) => (
                <Tooltip
                  title={t(
                    'APP.PROJECT.SIMULATOR.QUICK_SIMULATION.MORPHOLOGY.UNAVAILABLE_TOOLTIP',
                    { defaultValue: "D'autres choix seront bientôt disponibles" }
                  )}
                >
                  <SelectUi
                    {...field}
                    sx={selectStyle}
                    disabled={true}
                    value={generalConception.morphology.value}
                    style={{
                      width: '60%',
                    }}
                  >
                    <MenuItem value={generalConception.morphology.value}>
                      Rectangle
                    </MenuItem>
                  </SelectUi>
                </Tooltip>
              )}
            />
          </div>

          <div
            style={{
              display: 'flex',
              columnGap: '20px',
            }}
          >
            {RectangleSVG()}

            <div
              style={{
                display: 'flex',
                rowGap: '10px',
                flexDirection: 'column',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <label className="form-label">
                  {t(
                    'APP.PROJECT.SIMULATOR.QUICK_SIMULATION.FORM.LABEL.RECTANGLE_LENGTH',
                    {
                      defaultValue: 'Longueur',
                    }
                  )}
                </label>
                <div
                  style={{
                    display: 'flex',
                    columnGap: '8px',
                    alignItems: 'center',
                  }}
                >
                  <InputProjectSimulator
                    form={form}
                    name="length"
                    style={{ maxWidth: '40%' }}
                    defaultValue={generalConception.morphology.type.length}
                    rules={projectSimulatorFieldRules.positiveNumber}
                    hideValueIfFormNotPatched={true}
                  />
                  <span
                    style={{
                      fontSize: '9px',
                      color: '#789ADE',
                    }}
                  >
                    m
                  </span>
                </div>
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <label className="form-label">
                  {t(
                    'APP.PROJECT.SIMULATOR.QUICK_SIMULATION.FORM.LABEL.RECTANGLE_WIDTH',
                    {
                      defaultValue: 'Largeur',
                    }
                  )}
                </label>
                <div
                  style={{
                    display: 'flex',
                    columnGap: '8px',
                    alignItems: 'center',
                  }}
                >
                  <InputProjectSimulator
                    form={form}
                    name="width"
                    style={{ maxWidth: '40%' }}
                    defaultValue={generalConception.morphology.type.width}
                    rules={projectSimulatorFieldRules.positiveNumber}
                    hideValueIfFormNotPatched={true}
                  />
                  <span
                    style={{
                      fontSize: '9px',
                      color: '#789ADE',
                    }}
                  >
                    m
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginBottom: '16px',
            }}
          >
            <label className="form-label">
              {t(
                'APP.PROJECT.SIMULATOR.QUICK_SIMULATION.FORM.LABEL.RECTANGLE_LEVELS',
                {
                  defaultValue: 'Nombre de niveaux',
                }
              )}
            </label>
            <InputProjectSimulator
              form={form}
              name="numberOfLevels"
              style={{ width: '25%' }}
              defaultValue={generalConception.numberOfLevels}
              rules={projectSimulatorFieldRules.positiveNumber}
              hideValueIfFormNotPatched={true}
            />
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <label className="form-label">
              {t(
                'APP.PROJECT.SIMULATOR.QUICK_SIMULATION.FORM.LABEL.RECTANGLE_HEIGHT',
                {
                  defaultValue: 'Hauteur moyenne (m)',
                }
              )}
            </label>
            <InputProjectSimulator
              form={form}
              name="meanHeight"
              defaultValue={generalConception.meanHeight}
              style={{ width: '25%' }}
              rules={projectSimulatorFieldRules.positiveNumber}
              hideValueIfFormNotPatched={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default GeneralConception;
